import React from "react";
import ResortingAndPackagingListInfo from "../../../components/FactoryModule/ResortingAndPackagingList/ResortingAndPackagingList.component";

export default class ResortingAndPackagingScreen extends React.Component {
  render() {
    return <ResortingAndPackagingListInfo />;
  }
}
